import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { CITYWIDE_COMMON_SCHEMA, SEISAKU_EYE_SCHEMA } from "../lib/env";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim() ?? "";
const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim() ?? "";

let client: SupabaseClient | null = null;

export function isSupabaseConfigured() {
  return Boolean(supabaseUrl && supabasePublishableKey);
}

export function getSupabaseClient() {
  if (!isSupabaseConfigured()) return null;
  if (!client) {
    client = createClient(supabaseUrl, supabasePublishableKey, {
      auth: {
        autoRefreshToken: true,
        detectSessionInUrl: true,
        persistSession: true,
      },
    });
  }
  return client;
}

export function getCitywideCommonClient() {
  return getSupabaseClient()?.schema(CITYWIDE_COMMON_SCHEMA) ?? null;
}

export function getSeisakuEyeClient() {
  return getSupabaseClient()?.schema(SEISAKU_EYE_SCHEMA) ?? null;
}
